import styled, { css } from 'styled-components';

export const WrapperCard = styled.div<{ $spacing: string; $boxShadow: string }>`
  background: ${({ theme }) => theme.palette.white};

  box-shadow: ${({ theme }) => theme.boxShadow.sm};
  border-radius: ${({ theme }) => theme.rounded.x3};
  flex: 1;
  ${({ $spacing }) =>
    $spacing === 'md'
      ? css`
          padding: ${({ theme }) => theme.spacing.x4};
        `
      : $spacing === 'sm'
      ? css`
          padding: ${({ theme }) => theme.spacing.x3};
        `
      : css`
          padding: ${({ theme }) => theme.spacing.x3};
        `};

  ${({ $boxShadow }) =>
    $boxShadow === 'low'
      ? css`
          box-shadow: ${({ theme }) => theme.boxShadow.sm};
        `
      : $boxShadow === 'normal'
      ? css`
          box-shadow: ${({ theme }) => theme.boxShadow.md};
        `
      : css`
          box-shadow: ${({ theme }) => theme.boxShadow.md};
        `};
`;
